<div class="govuk-warning-text">
  <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
  <strong class="govuk-warning-text__text">
    <span class="govuk-warning-text__assistive">{{ assistiveText }}</span>
    <ng-content></ng-content>
  </strong>
</div>
